// spec 000211 (Q6) - the one place a native build decides which server it talks to.
// Native WebViews are served from capacitor://localhost (iOS) / https://localhost (Android), so a
// relative or empty API base can never reach the backend. Resolution order:
//   1. REACT_APP_NATIVE_API_ORIGIN - set per environment by `.env.native.<env>` (cap:build:<env>)
//   2. REACT_APP_API_BASE_URL, when it is absolute
//   3. production origin
// Web builds never call this: they keep the same-origin / REACT_APP_API_BASE_URL behavior.
export const NATIVE_DEFAULT_ORIGIN = 'https://advice-ev.com';

const isAbsolute = (url) => /^https?:\/\//i.test(url || '');

export function getNativeApiOrigin() {
    const nativeOrigin = process.env.REACT_APP_NATIVE_API_ORIGIN;
    if (isAbsolute(nativeOrigin)) return nativeOrigin.replace(/\/$/, '');

    const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;
    if (isAbsolute(configuredBaseUrl)) return configuredBaseUrl.replace(/\/$/, '');

    return NATIVE_DEFAULT_ORIGIN;
}
